import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AppRoute } from '@app/app-routes.enum';
import { MockService } from '@mock/mock.service';

export const mockEnabledGuard: CanActivateFn | CanMatchFn = () => {
  const router: Router = inject(Router);
  const mockService = inject(MockService);

  if (!mockService.isMockEnabled()) {
    return router.createUrlTree([AppRoute.Base]);
  }

  return true;
};
